document.addEventListener('DOMContentLoaded', function() {
    const closeButton = document.querySelector('.login_dropdown_modal__toggle');
    const loginDropdownList = document.querySelector('.header__icon--account-dropdown');
    const loginIcon = document.querySelector('.header__icons-login');

    function closeDropdown() {
        loginDropdownList.classList.remove('active');
        loginDropdownList.setAttribute('aria-hidden', 'true');
        loginDropdownList.setAttribute('aria-modal', 'false');
        loginIcon.removeAttribute('aria-expanded');
    }

    function openDropdown() {
        loginDropdownList.classList.add('active');
        loginDropdownList.setAttribute('aria-hidden', 'false');
        loginDropdownList.setAttribute('aria-modal', 'true');
        loginIcon.setAttribute('aria-expanded', 'true');

        loginDropdownList.focus();

        const customerLoggedIn = document.querySelector('.header__icon--account-user') !== null;
        const loginLinks = customerLoggedIn
            ? document.querySelectorAll('.header__icon--account-dropdown-content a')
            : document.querySelectorAll('.header__icon--account-dropdown-content a, .button-sso_header a');

        const focusableElements = [closeButton, ...loginLinks];
        setFocusTrap(focusableElements);
    }

    function setFocusTrap(focusableElements) {
        if (focusableElements.length > 0) {
            const firstElement = focusableElements[0];
            const lastElement = focusableElements[focusableElements.length - 1];

            firstElement.addEventListener('keydown', function(event) {
                if (event.shiftKey && event.key === 'Tab') {
                    closeDropdown();}
            });

            lastElement.addEventListener('keydown', function(event) {
                if (!event.shiftKey && event.key === 'Tab') {
                    closeDropdown();}
            });
        }
    }

    if (loginIcon) {
        loginIcon.addEventListener('keydown', function(event) {
            if (event.key === 'Enter') {
                event.stopPropagation();
                if (loginDropdownList.classList.contains('active')) {
                    closeDropdown();
                } else {
                    openDropdown();
                }
            }
        });
    }

    document.addEventListener('keydown', function(event) {
        if (event.key === 'Escape' && loginDropdownList.classList.contains('active')) {
            closeDropdown();
            loginIcon.focus();
        }
    });

    if (closeButton) {
        closeButton.addEventListener('click', function(event) {
            event.stopPropagation();
            closeDropdown();
            loginIcon.focus();
        });
    }

    if (loginIcon) {
        loginIcon.addEventListener('click', function(event) {
            event.stopPropagation();
            if (loginDropdownList.classList.contains('active')) {
                closeDropdown();
            } else {
                openDropdown();
            }
        });
    }

    if (loginDropdownList) {
        loginDropdownList.addEventListener('click', function(event) {
            event.stopPropagation();
        });
    }

    document.querySelector('body').addEventListener('click', function(event) {
        const loginDropdownButtonClicked = event.target.closest('.header__icons-login .header__icon');

        if (loginDropdownList && !loginDropdownButtonClicked) {
            closeDropdown();
        }
    });
});